export enum PartNextAction {
  None = 'None',
  HelpMeFindTheRightPart = 'HelpMeFindTheRightPart',
  Configure = 'Configure',
  EnterPartInformation = 'EnterPartInformation',
  ViewEditPartInformation = 'ViewEditPartInformation',
}
